import $ from 'jquery'

$(document).ready(function () {
	$('.js-expand').on('click', function (event) {
		let isMobile = $(window).width() <= 960;
		if (isMobile) {
			let el = $(this);
			el.parent().parent().toggleClass('is-open');
			if (el.hasClass('is-open')) {
				el.attr('aria-expanded', 'true')
				el.find('span.text').text('+ CLOSE')
			} else {
				el.attr('aria-expanded', 'false')
				el.find('span.text').text('+ EXPAND')
			}
		}
	});
});